import * as React from 'react';
import axios from 'axios';
import { GET_ERRORS, GET_ORDERS_LIST, GET_ORDER_DETAILS, GET_ORDER_ACTIVE_ID } from './types';
const api_url = process.env.REACT_APP_API_URL;


export const addOrder = (order, history) => dispatch => {
  // axios.post(api_url+'orders/add', order)
    //   .catch(err => {
    //       dispatch({
    //           type: GET_ERRORS,
    //           payload: err.response.data
    //       });
    //   });

    axios.post(api_url+'orders/add', order)
    .then(response => {
      dispatch({
          type: GET_ORDER_ACTIVE_ID,
          payload: response.data._id
      });
    })
    .catch(err => {
        dispatch({
            type: GET_ERRORS,
            payload: err.response.data
        });
    });
}

export const orderDetails = (order_id, history) => dispatch => {
  axios.get(
    api_url+'orders/details',
    { params: { order_id: order_id } }
  )
  .then(response => {
    dispatch({
        type: GET_ORDER_DETAILS,
        payload: response.data
    });
  });
}

export const orderActiveId = (order_id) => dispatch => {
  dispatch({
    type: GET_ORDER_ACTIVE_ID,
    payload: order_id
  });
}

export const listOrders = (currentorg, sort) => dispatch => {
  axios.get(
    api_url+'orders/list',
    { params: { organization: currentorg } }
  )
  .then(response => {
      let d = response.data;
      let s
      switch (sort) {
        case 'email':
          s = d.sort((a, b) => a.email.localeCompare(b.email));
          break;
        default:
          s = d.sort((a, b) => a.name.localeCompare(b.name));

      }
      dispatch({
          type: GET_ORDERS_LIST,
          payload: response.data
      });
  });
}
